import { JudgmentActionsEnum } from 'CorePackage/CatalogsModule/enums/JudgmentActionsEnum';
import { REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';
import { composeValidators } from 'CorePackage/MainModule/validators/composeValidators';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';

import { IKnmErknmFormJudgment } from '../interfaces/IKnmErknmFormJudgment';
import { IKnmErknmFormJudgmentAgainstInfo } from '../interfaces/IKnmErknmFormJudgmentAgainstInfo';
import { IKnmErknmFormJudgmentActsAndDecisions } from '../interfaces/IKnmErknmFormJudgmentActsAndDecisions';

const getJudgmentAgainstInfoValidate = (
  item: IKnmErknmFormJudgmentAgainstInfo | undefined,
  isPersonInfo: boolean | undefined,
  isCancellation: boolean,
): FormErrors<IKnmErknmFormJudgmentAgainstInfo> => {
  if (isPersonInfo === undefined) {
    return {};
  }

  return {
    officialPersonFio: isPersonInfo ? makeRequired('Поле не может быть пустым')(item?.officialPersonFio) : undefined,
    officialPersonJobTitle: isPersonInfo
      ? makeRequired('Поле не может быть пустым')(item?.officialPersonJobTitle)
      : undefined,
    prosecutionType: makeRequired('Поле не может быть пустым')(item?.prosecutionType),
    punishmentType: makeRequired('Поле не может быть пустым')(item?.punishmentType),
    amountOfPunishment: item?.punishmentType?.hasIndexAndAmount
      ? makeRequired('Поле не может быть пустым')(item?.amountOfPunishment)
      : undefined,
    punishmentIndex: item?.punishmentType?.hasIndexAndAmount
      ? makeRequired('Поле не может быть пустым')(item?.punishmentIndex)
      : undefined,
    cancellationInformation: isCancellation
      ? makeRequired('Поле не может быть пустым')(item?.cancellationInformation)
      : undefined,
    explanation: isCancellation ? makeRequired('Поле не может быть пустым')(item?.explanation) : undefined,
  };
};

const getJudgmentActsAndDecisionsValidate = (
  item: IKnmErknmFormJudgmentActsAndDecisions | undefined,
  isCancellation: boolean,
): FormErrors<IKnmErknmFormJudgmentActsAndDecisions> => {
  if (!item) {
    return {};
  }

  return {
    explanation: !isCancellation ? makeRequired('Поле не может быть пустым')(item.explanation) : undefined,
    newCancellationInformation: isCancellation
      ? makeRequired('Поле не может быть пустым')(item.newCancellationInformation)
      : undefined,
    newExplanation: isCancellation ? makeRequired('Поле не может быть пустым')(item.newExplanation) : undefined,
  };
};

export const getJudgmentsValidate = (judgments: IKnmErknmFormJudgment[] | undefined) => {
  return judgments?.map(item => {
    const isAddJudgment = item.judgmentAction === JudgmentActionsEnum.ADD_JUDGMENT;
    const isAnnulmentAkt = item.judgmentAction === JudgmentActionsEnum.ANNULMENT_AKT;
    const isAddOrAnnulmentAkt = isAddJudgment || isAnnulmentAkt;
    const isAnnulmentJudgment = item.judgmentAction === JudgmentActionsEnum.ANNULMENT_JUDGMENT;
    const isRequiredSubjectData = isAddOrAnnulmentAkt || (isAnnulmentJudgment && item.createNewJudgment);

    return {
      dateJudgment: makeRequired('Поле не может быть пустым')(item.dateJudgment),
      numberJudgment: makeRequired('Поле не может быть пустым')(item.numberJudgment),
      kindJudgment: makeRequired('Поле не может быть пустым')(item.kindJudgment),
      attachment: makeRequired('Поле не может быть пустым')(item.attachment),
      rfRegionCode: makeRequired('Поле не может быть пустым')(item.rfRegionCode),
      court: makeRequired('Поле не может быть пустым')(item.court),
      courtLevelCode: makeRequired('Поле не может быть пустым')(item.courtLevelCode),
      judgmentAction: makeRequired('Поле не может быть пустым')(item.judgmentAction),
      judgmentSubjectData:
        (isAddOrAnnulmentAkt || item.createNewJudgment) && !item.judgmentSubjectData?.length
          ? makeRequired('Поле не может быть пустым')(item.judgmentSubjectData)
          : item.judgmentSubjectData?.map(subjectData => ({
              organizationGuid: isRequiredSubjectData
                ? composeValidators(makeRequired(REQUIRED_ERROR))(subjectData.organizationGuid)
                : undefined,
              isJudgmentAgainstOrganizations:
                isAddJudgment &&
                !subjectData.isJudgmentAgainstOrganizations &&
                !subjectData.isJudgmentAgainstOfficialPerson
                  ? makeRequired('Поле не может быть пустым')(subjectData.isJudgmentAgainstOrganizations)
                  : undefined,
              isJudgmentAgainstOfficialPerson:
                isAddJudgment &&
                !subjectData.isJudgmentAgainstOrganizations &&
                !subjectData.isJudgmentAgainstOfficialPerson
                  ? makeRequired('Поле не может быть пустым')(subjectData.isJudgmentAgainstOfficialPerson)
                  : undefined,
              judgmentAgainstOrganizations: subjectData.isJudgmentAgainstOrganizations
                ? {
                    ...getJudgmentAgainstInfoValidate(subjectData.judgmentAgainstOrganizations, false, false),
                  }
                : undefined,
              judgmentAgainstOfficialPerson:
                subjectData.isJudgmentAgainstOfficialPerson && !subjectData.judgmentAgainstOfficialPerson?.length
                  ? makeRequired('Поле не может быть пустым')(subjectData.judgmentAgainstOfficialPerson)
                  : subjectData.judgmentAgainstOfficialPerson?.map(officialPerson => ({
                      ...getJudgmentAgainstInfoValidate(officialPerson, true, false),
                    })),
              cancellationActsAndDecisions:
                isAnnulmentAkt && !subjectData.cancellationActsAndDecisions?.length
                  ? makeRequired('Поле не может быть пустым')(subjectData.cancellationActsAndDecisions)
                  : subjectData.cancellationActsAndDecisions?.map(cancellationActOrDecision => ({
                      ...getJudgmentActsAndDecisionsValidate(cancellationActOrDecision, false),
                    })),
            })),
      canceledJudgments:
        isAnnulmentJudgment && !item.canceledJudgments?.length
          ? makeRequired('Поле не может быть пустым')(item.canceledJudgments)
          : item.canceledJudgments?.map(canceledJudgment => ({
              guid: isAnnulmentJudgment ? makeRequired('Поле не может быть пустым')(item.canceledJudgments) : undefined,
              judgmentSubjectData: isAnnulmentJudgment
                ? canceledJudgment.judgmentSubjectData?.map(subjectData => ({
                    judgmentAgainstOrganizations: subjectData.isJudgmentAgainstOrganizations
                      ? {
                          ...getJudgmentAgainstInfoValidate(subjectData.judgmentAgainstOrganizations, false, true),
                        }
                      : undefined,
                    judgmentAgainstOfficialPerson: subjectData.isJudgmentAgainstOfficialPerson
                      ? subjectData.judgmentAgainstOfficialPerson?.map(officialPerson => ({
                          ...getJudgmentAgainstInfoValidate(officialPerson, true, true),
                        }))
                      : undefined,
                    cancellationActsAndDecisions: subjectData.cancellationActsAndDecisions?.map(
                      cancellationActOrDecision => ({
                        ...getJudgmentActsAndDecisionsValidate(cancellationActOrDecision, true),
                      }),
                    ),
                  }))
                : undefined,
            })),
    };
  });
};
